"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.organizations = exports.UpdateSuperAdminEnum = void 0;
const createApi_1 = require("../../helpers/createApi");
const membership_1 = require("./membership");
var UpdateSuperAdminEnum;
(function (UpdateSuperAdminEnum) {
    UpdateSuperAdminEnum["include_super_admins"] = "include_super_admins";
    UpdateSuperAdminEnum["exclude_super_admins"] = "exclude_super_admins";
    UpdateSuperAdminEnum["exclude_membership"] = "exclude_membership";
})(UpdateSuperAdminEnum = exports.UpdateSuperAdminEnum || (exports.UpdateSuperAdminEnum = {}));
const get = (caller) => ({ accountId }) => {
    const url = `/accounts/${accountId}/organizations`;
    return caller(url).get();
};
const patch = (caller) => ({ accountId, organizationId = 'default', ...payload }) => {
    const url = `/accounts/${accountId}/organizations/${organizationId}`;
    return caller(url).patch(payload);
};
exports.organizations = (0, createApi_1.createAPIFactory)({
    get,
    patch,
    membership: membership_1.membership,
});
//# sourceMappingURL=api.js.map